import { Timeline } from 'antd';
import { DeviceMobileIcon, DesktopIcon, CheckCircleIcon, XCircleIcon } from '@phosphor-icons/react';
import { mockLoginEvents } from 'mock/user-detail.mock';

const LoginHistoryTab = () => (
    <div className="pb-6 pt-2 px-6">
        <Timeline
            items={mockLoginEvents.map(ev => ({
                dot: (
                    <div className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 ${ev.status === 'success' ? 'bg-green-100 dark:bg-green-900/40' : 'bg-red-100 dark:bg-red-900/40'}`}>
                        {ev.status === 'success'
                            ? <CheckCircleIcon size={16} weight="fill" className="text-green-600 dark:text-green-400" />
                            : <XCircleIcon size={16} weight="fill" className="text-red-500 dark:text-red-400" />
                        }
                    </div>
                ),
                children: (
                    <div className="pb-2">
                        <div className="flex items-center gap-1.5 mb-0.5">
                            {ev.isMobile
                                ? <DeviceMobileIcon size={13} className="text-gray-400 dark:text-gray-500 shrink-0" />
                                : <DesktopIcon size={13} className="text-gray-400 dark:text-gray-500 shrink-0" />
                            }
                            <span className="text-sm font-medium text-gray-800 dark:text-gray-200">{ev.device}</span>
                        </div>
                        <p className="text-xs text-gray-400 dark:text-gray-500 m-0">{ev.browser} · {ev.location}</p>
                        <p className="text-xs text-gray-400 dark:text-gray-500 m-0 mt-0.5">{ev.time}</p>
                    </div>
                ),
            }))}
        />
    </div>
);

export default LoginHistoryTab;
